import React from 'react';
import { LazyMotion, MotionConfig, domAnimation } from 'motion/react';

export const MotionProvider = ({ children }) => (
  <LazyMotion features={domAnimation} strict>
    <MotionConfig reducedMotion="user">
      {children}
    </MotionConfig>
  </LazyMotion>
);
